import { request } from "../../utils/AxiosInstance";
export const getRole = async (params) => {
  return request({ url: "getrole", params: params });
};
